import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Pourcentage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pourcentage: Math.floor(Math.random() * 50) + 1,
      number: Math.floor(Math.random() * 100) + 1,
      answer: "",
      min: 2,
      maxPourcentage: 50,
      maxNumber: 100,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerOperation = (event) => {
    event.preventDefault();
    var good = (this.state.pourcentage * this.state.number) / 100;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.pourcentage +
          "% de " +
          this.state.number +
          " = " +
          good,
      });
    } else if ((Number(this.state.answer) >= (good-1)) && (Number(this.state.answer) <= (good+1)))  {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Presque, réponse exacte : " +
          this.state.pourcentage +
          "% de " +
          this.state.number +
          " = " +
          good + 
          " (réponse donnée : " +
          this.state.answer + ")"
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.pourcentage +
          "% de " +
          this.state.number +
          " = " +
          good,
      });
    }
    var pourcent =
      Math.floor(
        Math.random() * (Number(this.state.maxPourcentage) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    var num =
      Math.floor(
        Math.random() * (Number(this.state.maxNumber) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    this.setState({ pourcentage: pourcent, number: num, answer: ""});
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  // componentDidMount() {
  //
  // }

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Pourcentage</h2>
          </div>
        </div>

        <div className="container">
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerOperation}
          >
            <p
              className={this.state.messageColor}
              style={{ marginTop: 40, marginBottom: 20 }}
            >
              {this.state.message}
            </p>
            <div className="row">
              <label className="label-exos">
                {this.state.pourcentage}% de {this.state.number} = ?
              </label>
            </div>
            <input
              className="input-square"
              type="float"
              name="answer"
              value={this.state.answer} 
              onChange={this.myChangeHandler}
            />
            <input
              className="validate-button"
              style={{ backgroundColor: "#00cfa4" }}
              type="submit"
              value="Valider"
            />
          </form>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Pourcentage;
